import ArrowForwardIcon from "../../assets/icons/arrow_forward.svg?react";
import { cn } from "../../utils/classNames";
import useMarkDemandStudioOpened from "../../hooks/useMarkDemandStudioOpened";
import useDemandStudioReturnRoute from "../../hooks/useDemandStudioReturnRoute";
import XLink from "../common/XLink";

const arrowClasses = 'ml-auto h-action-arrow-h w-action-arrow-w flex-none';

// Appearance comes from the variant's aria-disabled rules; this only blocks interaction.
const disabledLinkClasses = 'pointer-events-none opacity-100';

const DemandStudioButton = ({ caseId, className, title = "Demand Studio", disabled = false, onClick }) => {
  const markOpened = useMarkDemandStudioOpened(caseId);
  const { saveReturnRoute } = useDemandStudioReturnRoute();

  return (
    <XLink
      to={`/case/${caseId}/demand-studio`}
      variant="actionOutline"
      className={cn(disabled && disabledLinkClasses, className)}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      onClick={disabled ? undefined : () => { saveReturnRoute(); markOpened(); onClick?.(); }}
    >
      <span>{title}</span>
      <ArrowForwardIcon className={arrowClasses} />
    </XLink>
  );
};

export default DemandStudioButton;
